module.exports = __webpack_public_path__ + "components/resort-guide/item/static/icon-drag-lift--black-45d9528bc1f9d872b5401ab32d5ed13b.svg";